import { useParams } from 'react-router-dom';

import { productStore } from 'containers/Products/Product/store';
import { CRUDTable } from 'components';

import { useGetCompanies, usePatchRequest, usePostRequest, useUserRole } from 'hooks';

import { ProductExclusion, ProductExclusionUpdate } from 'codegen';

import {
  columns,
  handlePatchExclusions,
  handlePostExclusions,
  handleSuccessPatchExclusions,
  handleSuccessPostExclusions,
  initialTableActions,
} from './lib';

export const Exclusions = () => {
  const exclusions = productStore((state) => state.exclusions);

  const { productId } = useParams();

  const [{ companies }] = useGetCompanies(true);

  const [postExclusions, { loading }] = usePostRequest<ProductExclusion, ProductExclusionUpdate>({
    options: {
      onSuccess: handleSuccessPostExclusions(exclusions),
    },
  });

  const [patchExclusions, { loading: patchLoading }] = usePatchRequest<ProductExclusion, ProductExclusionUpdate>({
    options: {
      onSuccess: handleSuccessPatchExclusions(exclusions),
    },
  });

  const { isAdmin } = useUserRole();

  return (
    <CRUDTable
      loading={loading || patchLoading}
      columns={columns(companies)}
      addNewBtn={{ visible: isAdmin }}
      dataSource={exclusions}
      initialTableActions={isAdmin ? initialTableActions : undefined}
      onPostTableData={handlePostExclusions(postExclusions, productId)}
      onPatchTableData={handlePatchExclusions(patchExclusions, productId)}
    />
  );
};
